"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSize = void 0;
const react_1 = require("react");
const resize_observer_1 = __importDefault(require("@react-hook/resize-observer"));
const useSize = (ref) => {
    const [size, setSize] = (0, react_1.useState)();
    (0, resize_observer_1.default)(ref, (entry) => setSize(entry.contentRect));
    return size;
};
exports.useSize = useSize;
